// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4336":"4e59ed59","5318":"1ec96583","7695":"1ec96583","8689":"e2d96e67"}[chunkId] + ".chunk.css";
};